var _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _g3, _g4, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuiz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.6 175C59.1775 175 25.6001 141.423 25.6001 100C25.6001 58.5774 59.1775 25 100.6 25C142.023 25 175.6 58.5774 175.6 100C175.6 141.423 142.023 175 100.6 175Z",
    fill: "url(#paint0_linear_26801_1771)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.539 111.868H27.211L16.6001 86.9338L27.211 62H172.539L183.15 86.9338L172.539 111.868Z",
    fill: "url(#paint1_linear_26801_1771)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6243 121.868L16.6001 133.716L21.6243 145.527H90.4641L95.4883 133.716L90.4641 121.868H21.6243Z",
    fill: "url(#paint2_linear_26801_1771)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M179.352 145.527L184.376 133.716L179.352 121.868H110.513L105.488 133.716L110.513 145.527H179.352Z",
    fill: "url(#paint3_linear_26801_1771)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6243 153.526L16.6001 165.337L21.6243 177.148H90.4641L95.4883 165.337L90.4641 153.526H21.6243Z",
    fill: "url(#paint4_linear_26801_1771)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.513 153.526L105.488 165.337L110.513 177.148H179.352L184.376 165.337L179.352 153.526H110.513Z",
    fill: "url(#paint5_linear_26801_1771)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_26801_1771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.6921 76.8478H41.9837C40.034 76.8478 38.4592 78.4225 38.4592 80.3723C38.4592 82.322 40.034 83.8967 41.9837 83.8967H69.6921C71.6418 83.8967 73.2165 82.322 73.2165 80.3723C73.179 78.4225 71.6043 76.8478 69.6921 76.8478Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_26801_1771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.9534 80.3723C78.9534 82.322 80.5281 83.8967 82.4778 83.8967H157.804C159.754 83.8967 161.329 82.322 161.329 80.3723C161.329 78.4225 159.754 76.8478 157.804 76.8478H82.4403C80.4906 76.8478 78.9534 78.4225 78.9534 80.3723Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_26801_1771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9837 97.9946H108.199C110.149 97.9946 111.723 96.4199 111.723 94.4701C111.723 92.5204 110.149 90.9457 108.199 90.9457H41.9837C40.034 90.9457 38.4592 92.5204 38.4592 94.4701C38.4592 96.4199 40.034 97.9946 41.9837 97.9946Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_26801_1771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.76 97.9946H157.804C159.754 97.9946 161.329 96.4199 161.329 94.4701C161.329 92.5204 159.754 90.9457 157.804 90.9457H120.76C118.81 90.9457 117.235 92.5204 117.235 94.4701C117.235 96.4199 118.81 97.9946 120.76 97.9946Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.6 75L94.4749 66.8925C83.4749 64.1399 75.6001 54.1846 75.6001 42.8234C75.6001 29.135 86.8144 18 100.6 18C114.386 18 125.6 29.135 125.6 42.8234C125.6 54.1846 117.725 64.1399 106.725 66.8925L100.6 75Z",
    fill: "url(#paint6_linear_26801_1771)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.8492 35.0165C98.4033 34.3887 99.2046 34 100.1 34C101.757 34 103.1 35.3432 103.1 37C103.1 38.3965 102.143 39.577 100.845 39.9076C99.1617 40.336 97.1001 41.8852 97.1001 44.5V46C97.1001 47.6569 98.4432 49 100.1 49C101.757 49 103.1 47.6569 103.1 46V45.487C106.594 44.2513 109.1 40.9216 109.1 37C109.1 32.0295 105.071 28 100.1 28C97.4115 28 94.9956 29.1826 93.3509 31.0461C92.2545 32.2883 92.3727 34.1841 93.6149 35.2805C94.857 36.3769 96.753 36.2587 97.8492 35.0165ZM100.1 51.9999C98.4433 51.9999 97.1002 53.343 97.1002 55C97.1002 56.6569 98.4433 58 100.1 58H100.13C101.787 58 103.13 56.6569 103.13 55C103.13 53.343 101.787 51.9999 100.13 51.9999H100.1Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_26801_1771",
    x: 38.4592,
    y: 75.8478,
    width: 34.7573,
    height: 8.04895,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_1771"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_1771"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_1771",
    result: "effect2_innerShadow_26801_1771"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_26801_1771",
    x: 78.9534,
    y: 75.8478,
    width: 82.3752,
    height: 8.04895,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_1771"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_1771"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_1771",
    result: "effect2_innerShadow_26801_1771"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_26801_1771",
    x: 38.4592,
    y: 89.9457,
    width: 73.2642,
    height: 8.04895,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_1771"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_1771"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_1771",
    result: "effect2_innerShadow_26801_1771"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_26801_1771",
    x: 117.235,
    y: 89.9457,
    width: 44.0935,
    height: 8.04895,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_1771"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_1771"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_1771",
    result: "effect2_innerShadow_26801_1771"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_1771",
    x1: 25.6001,
    y1: 36.7188,
    x2: 168.569,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_1771",
    x1: 99.8751,
    y1: 62,
    x2: 99.8751,
    y2: 111.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_1771",
    x1: 25.2285,
    y1: 121.868,
    x2: 49.0385,
    y2: 171.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26801_1771",
    x1: 144.932,
    y1: 121.868,
    x2: 144.932,
    y2: 145.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26801_1771",
    x1: 56.0442,
    y1: 153.526,
    x2: 56.0442,
    y2: 177.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26801_1771",
    x1: 144.932,
    y1: 153.526,
    x2: 144.932,
    y2: 177.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26801_1771",
    x1: 81.0688,
    y1: 18,
    x2: 142.876,
    y2: 51.7966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiz);
export default __webpack_public_path__ + "static/media/Quiz.6022371f7760313be9786485b1eb7f88.svg";
export { ForwardRef as ReactComponent };